import React, { useState } from "react";
import "./SignIn.css";
import logo from "../logo.jpg";
import { Link, useNavigate } from "react-router-dom";
import { authApi } from "../../api/client";
import { getApiErrorMessage } from "../../api/http";
import { useAuth } from "../../context/AuthContext";

const SignIn = () => {
  const [role, setRole] = useState("student");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setAuthSession } = useAuth();

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await authApi.login({ phone, password });
      const backendRole = data?.user?.role;

      if (backendRole !== "super_admin" && backendRole && backendRole !== role) {
        setError(`This account is ${backendRole} type. Please choose ${backendRole}.`);
        setLoading(false);
        return;
      }

      setAuthSession(data.token, data.user);
      navigate("/tracks");
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to sign in"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container d-flex align-items-center justify-content-center">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Left Side: Branding */}
          <div className="col-lg-6 text-white pe-lg-5 mb-5 mb-lg-0">
            <div className="d-flex align-items-center mb-4">
              <div className="logo-placeholder me-4">
                <img src={logo} className='rounded-circle' alt="IEEE Logo" width="75" />
              </div>
              <h2 className="fw-bold m-0">IEEE Study Groups</h2>
            </div>
            <h1 className="display-4 fw-bold mb-4">Expand your <br /> academic horizon.</h1>
            <p className="lead opacity-75 mb-4">
              Whether you are here to discover or to improve. 
              IEEE Study Groups bridges the gap between you and real 
              experience with Instructors that understand what you really 
              love and need to be better and always improving.
            </p>
            <p className="fw-semibold">Start The Journey now !</p>
          </div>

          {/* Right Side: Login Card */}
          <div className="col-lg-5 offset-lg-1">
            <div className="card login-card p-4 p-md-5 border-0 shadow-lg">
              <div className="text-center mb-4">
                <h2 className="fw-bold">Welcome back</h2>
                <p className="text-muted small">Please enter your details to sign in</p>
              </div>

              {/* Role Switcher */}
              <div className="role-switcher d-flex p-1 mb-4">
                <button
                  type="button"
                  className={`btn flex-fill rounded-pill ${role === 'student' ? 'bg-white shadow-sm' : 'text-muted'}`}
                  onClick={() => setRole('student')}
                >
                  Student
                </button>
                <button
                  type="button"
                  className={`btn flex-fill rounded-pill ${role === 'instructor' ? 'bg-white shadow-sm' : 'text-muted'}`}
                  onClick={() => setRole('instructor')}
                >
                  Instructor
                </button>
              </div>

              {/* Form */}
              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="form-label small fw-semibold text-muted">Phone Number</label>
                  <input
                    type="text"
                    className="form-control custom-input"
                    placeholder="01006969123"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <div className="d-flex justify-content-between">
                    <label className="form-label small fw-semibold text-muted">Password</label>
                    <Link to="/forgot-password" className="small text-decoration-none fw-bold">Forgot Password?</Link>
                  </div>
                  <input
                    type="password"
                    className="form-control custom-input"
                    placeholder="Enter Your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                {error ? <div className="alert alert-danger py-2 small">{error}</div> : null}
                <button type="submit" disabled={loading} className="btn btn-primary w-100 py-2 fw-bold mt-3 btn-signin">
                  {loading ? "Signing in..." : "Sign In"}
                </button>
              </form>

              <div className="text-center mt-4">
                <p className="small text-muted">
                  Don't have an account? <Link to="/signup" className="fw-bold text-decoration-none">Create an account</Link>
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SignIn;
